import React from "react";

export const RoseMark = ({ size = 40, className = "" }) => (
  <img
    src="/logo-mark.png"
    alt=""
    width={size}
    height={Math.round(size * 0.92)}
    className={className}
    aria-hidden="true"
  />
);

export const Logo = ({ light = false }) =>
  light ? (
    <span className="inline-flex bg-[#FDFBF7] rounded-xl px-4 py-2.5" data-testid="brand-logo">
      <img src="/logo-full.png" alt="Rosevale Accountants" className="h-8 w-auto" />
    </span>
  ) : (
    <img
      src="/logo-full.png"
      alt="Rosevale Accountants"
      data-testid="brand-logo"
      className="h-9 sm:h-10 w-auto"
    />
  );
